import { PaginationSizeOption } from './_types'

export const itemsPerPageOptions: PaginationSizeOption[] = [
  {
    value: 30,
    label: '30',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
  {
    value: 150,
    label: '150',
  },
  {
    value: 200,
    label: '200',
  },
]
